module.exports = __webpack_public_path__ + "img/spider-large.e3b7ff26.svg";